/**
 * Library
 */
export const REQUEST_LIBRARY_COUNT = 'library/REQUEST_LIBRARY_COUNT' as const;
export const REQUEST_LIBRARY_COUNT_SUCCESS = 'library/REQUEST_LIBRARY_COUNT_SUCCESS' as const;
export const REQUEST_LIBRARY_COUNT_FAILURE = 'library/REQUEST_LIBRARY_COUNT_FAILURE' as const;

export const REQUEST_LIBRARY_LIST = 'library/REQUEST_LIBRARY_LIST' as const;
export const REQUEST_LIBRARY_LIST_SUCCESS = 'library/REQUEST_LIBRARY_LIST_SUCCESS' as const;
export const REQUEST_LIBRARY_LIST_FAILURE = 'library/REQUEST_LIBRARY_LIST_FAILURE' as const;

export const INSERT_LIBRARY = 'library/INSERT_LIBRARY' as const;
export const INSERT_LIBRARY_SUCCESS = 'library/INSERT_LIBRARY_SUCCESS' as const;
export const INSERT_LIBRARY_FAILURE = 'library/INSERT_LIBRARY_FAILURE' as const;

export const DOWNLOAD_LIBRARY = 'library/DOWNLOAD_LIBRARY' as const;
export const DOWNLOAD_LIBRARY_SUCCESS = 'library/DOWNLOAD_LIBRARY_SUCCESS' as const;
export const DOWNLOAD_LIBRARY_FAILURE = 'library/DOWNLOAD_LIBRARY_FAILURE' as const;

export const DOWNLOAD_LIBRARY_CLOUDFRONT = 'library/DOWNLOAD_LIBRARY_CLOUDFRONT' as const;
export const DOWNLOAD_LIBRARY_CLOUDFRONT_SUCCESS =
  'library/DOWNLOAD_LIBRARY_CLOUDFRONT_SUCCESS' as const;
export const DOWNLOAD_LIBRARY_CLOUDFRONT_FAILURE =
  'library/DOWNLOAD_LIBRARY_CLOUDFRONT_FAILURE' as const;

/**
 * Mediaconvert Job
 */
export const REQUEST_MEDIACONVERT_JOB_LIST = 'library/REQUEST_MEDIACONVERT_JOB_LIST_LIST' as const;
export const REQUEST_MEDIACONVERT_JOB_LIST_SUCCESS =
  'library/REQUEST_MEDIACONVERT_JOB_LIST_SUCCESS' as const;
export const REQUEST_MEDIACONVERT_JOB_LIST_FAILURE =
  'library/REQUEST_MEDIACONVERT_JOB_LIST_FAILURE' as const;
